import { render, staticRenderFns } from "./ContactModal.vue?vue&type=template&id=21bc959b&scoped=true&"
import script from "./ContactModal.vue?vue&type=script&lang=js&"
export * from "./ContactModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactModal.vue?vue&type=style&index=0&id=21bc959b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc959b",
  null
  
)

export default component.exports